import { ComponentInstall } from "../../utils";
import AutoComplete from "./src";

export default ComponentInstall(AutoComplete);
